import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  importAudience(data) {
    return axios.post(`${this.url}/import_audience`, data);
  }

  createWithAudience(data) {
    return axios.post(`${this.url}/create_with_audience`, data);
  }

  start(id) {
    return axios.post(`${this.url}/${id}/start`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }
}

export default new CampaignsAPI();
